module.exports = __webpack_public_path__ + "img/intro-common-voice-teacher.e96e4418.jpg";